import type { EmployeeNotification } from '../api/employeeNotificationsApi';

interface NoticeToastProps {
  notice: EmployeeNotification;
  /** The red heading of a vessel notice; none for the normal bell. */
  heading?: string;
  onClick: () => void;
}

/** A new notice popped up by the socket; clicking it opens the notice. */
export function NoticeToast({ notice, heading, onClick }: NoticeToastProps) {
  return (
    <button type="button" className="text-left text-sm" onClick={onClick}>
      {heading && <span className="block text-[10px] font-black uppercase tracking-wide text-red-600">{heading}</span>}
      <b>{notice.title}</b>
      {notice.body && <div className="text-xs text-slate-500">{notice.body}</div>}
    </button>
  );
}
